module.exports = __webpack_public_path__ + "static/media/centre-aut.fc9edfc4.png";